export namespace CSInventoryReportDocConst {
  export const DocIDConstList = [
    {
      docName: 'BB kiểm kê tiền mặt- Cashcount kế toán',
      docID: '40101961',
      mainDoc: 'GA DOCUMENT',
      subDoc: 'Inventory record - Cashcount by FO',
      docNo: 'D1284'
    },

    {
      docName: 'BB kiểm kê tiền mặt của GA gửi CSA',
      docID: '40101971',
      mainDoc: 'GA DOCUMENT',
      subDoc: 'Inventory record - Cashcount by CSA',
      docNo: 'D1285'
    },
    {
      docName: 'BB visit/BB QC',
      docID: '40101981',
      mainDoc: 'GA DOCUMENT',
      subDoc: 'Other records',
      docNo: 'D1286'
    },
  ]
}